import React, { useEffect, useState } from 'react';

import { Col, Row } from 'antd';
import routePaths from 'config/routes';
import { NextPage } from 'next';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import FooterCols from 'src/components/layout/FooterCols';
import { getFooter } from 'src/components/menu/Menu.utils';
import { IRootReducers } from 'src/reducers';
import { IMenu } from 'src/shared/models';

const { LOGIN, SIGNUP } = routePaths.PAGES;

const { RR_SS_FACEBOOK, RR_SS_INSTAGRAM } = getConfig().publicRuntimeConfig;

type Props = ReturnType<typeof mapStateToProps>;

const BasicPreFooterMenu: NextPage<Props, {}> = ({
  authenticated,
  publicMenu,
  privateMenu,
}) => {
  const { formatMessage } = useIntl();
  const { pathname } = useRouter();
  const [menu, setMenu] = useState<IMenu[]>(
    getFooter(authenticated, publicMenu, privateMenu, false)
  );

  useEffect(() => {
    setMenu(getFooter(authenticated, publicMenu, privateMenu, false));
  }, [authenticated, publicMenu, privateMenu]);

  const renderCustomerCare =
    pathname.includes(LOGIN) || pathname.includes(SIGNUP);

  const customerCareFooter = (
    <div className="pre-footer-contact container--no-padding">
      <Row align="middle" justify="center">
        <div className="icon icon--ilustration-headphones footer-headphone-icon" />
        <div>
          <p className="footer-text">
            {formatMessage({ id: 'footer.customer-care' })}
          </p>
          <p className="footer-text">862-242-8129</p>
        </div>
      </Row>
    </div>
  );

  const componentCustomMenu = FooterCols(menu, false, authenticated);

  const getRRSS_Icons = (customClass: string) => {
    return (
      <Col xs={24} lg={8} className={`container-RRSS ${customClass}`}>
        <Row>
          <a
            className="icon icon--facebook"
            href={RR_SS_FACEBOOK}
            target="_blank"
            rel="noreferrer"
          />
          <a
            className="icon icon--instagram"
            href={RR_SS_INSTAGRAM}
            target="_blank"
            rel="noreferrer"
          />
        </Row>
      </Col>
    );
  };

  const basicFooter = (
    <div className="pre-footer container--no-padding">
      <Row
        className={`pre-footer__wrapper container--no-padding ${
          authenticated ? '' : 'pre-footer__wrapper--not-logged'
        }`}
        justify="start"
      >
        {!authenticated &&
          getRRSS_Icons('show_on_breakpoint-md container-RRSS__not-logged')}
        <Col
          xs={24}
          lg={authenticated ? 16 : 8}
          className="container-footer-menus"
        >
          <Row className="container" justify="space-between">
            {componentCustomMenu}
          </Row>
        </Col>
        {getRRSS_Icons(
          authenticated
            ? 'container-RRSS__desktop'
            : 'not_show_on_breakpoint-md'
        )}
      </Row>
    </div>
  );

  return renderCustomerCare ? customerCareFooter : basicFooter;
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    authenticated:
      state.auth.accessToken !== null && state.auth.accessToken !== '',
    userStatus: state.auth.userStatus,
    publicMenu: state.app.publicMenu,
    privateMenu: state.app.userMenu,
  };
};

export default connect(mapStateToProps, null)(BasicPreFooterMenu);
